var _rect, _path, _path2, _path3, _path4, _circle, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    rx: 16,
    fill: "#F4F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M59.9961 33.4819C59.9961 40.7613 54.1774 46.6621 46.9992 46.6621C39.821 46.6621 34.0022 40.7613 34.0022 33.4819H59.9961Z",
    fill: "url(#paint0_linear_19570_375298)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61 34.3312V33.3312H59V34.3312H61ZM59 34.3312C59 40.9571 53.629 46.3281 47.0031 46.3281V48.3281C54.7335 48.3281 61 42.0617 61 34.3312H59ZM47.0031 46.3281C40.3772 46.3281 35.0061 40.9571 35.0061 34.3312H33.0061C33.0061 42.0617 39.2726 48.3281 47.0031 48.3281V46.3281Z",
    fill: "#FF697A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9961 35.1947C33.9961 27.1738 28.1774 20.6719 20.9992 20.6719C13.821 20.6719 8.00224 27.1738 8.00224 35.1947H33.9961Z",
    fill: "url(#paint1_linear_19570_375298)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34 34.3309C34 27.1527 28.1813 21.334 21.0031 21.334C13.8249 21.334 8.00614 27.1527 8.00614 34.3309",
    stroke: "#35DB80",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.0016,
    cy: 34.2692,
    r: 10.0954,
    fill: "white",
    stroke: "#ADBAD1",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6315 27.918H37.1981C37.5595 27.918 37.8016 28.2897 37.6554 28.6202L35.5568 33.3646H37.7103C38.1436 33.3646 38.3718 33.8782 38.0814 34.1998L32.5868 40.2827C32.2442 40.662 31.6205 40.3437 31.7267 39.8437L32.5045 36.1813C32.5705 35.8703 32.3333 35.5774 32.0154 35.5774H30.2426C29.8963 35.5774 29.6549 35.2339 29.7722 34.9081L29.917 34.5058C29.9217 34.484 29.9279 34.4622 29.9357 34.4404L32.1609 28.2489C32.2323 28.0504 32.4205 27.918 32.6315 27.918Z",
    fill: "#37435A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2371 35.0257L50.2371 38.2631H52.3961V35.0257H55.6361V32.8667H52.3961V29.627L50.2371 29.627L50.2371 32.8667H47V35.0257H50.2371Z",
    fill: "#35DB80"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3672 32.8652H21.0033V35.0243H12.3672V32.8652Z",
    fill: "#FF697A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19570_375298",
    x1: 46.9992,
    y1: 46.6621,
    x2: 46.9992,
    y2: 33.4819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF697A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF697A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19570_375298",
    x1: 20.9992,
    y1: 20.6719,
    x2: 20.9992,
    y2: 35.1947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64E8A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64E8A4",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDr);
export default __webpack_public_path__ + "static/media/dr.35147bf8b1e9a2c070083f5927bb20ce.svg";
export { ForwardRef as ReactComponent };